import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import style from './style'
import VerbalColorType from '../../helpers/types/VerbalColor.interface'

const useStyles = makeStyles(style)

interface PropsInterface extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    color?: VerbalColorType;
    'data-testid'?: string;
}

/**
 *
 */
const Link = ({
    children,
    className = '',
    color = 'primary',
    'data-testid': dataTestId = 'link',
    ...props
}: PropsInterface): JSX.Element => {
    const styles = useStyles()

    return (
        <a
            {...props}
            className={`${className} ${styles.link} link--${color}`}
            data-testid={dataTestId}
        >
            {children}
        </a>
    )
}

export default Link
